import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import TilpassetBilde from './components/tilpasset-bilde'

import './client.module.css'
import './components/tilpasset-bilde.module.css'
const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends BaseElement {
  name = tag

  connectedCallback() {
    super.connectedCallback()

    if (this.features.sanityIframePreview) {
      import('./components/preview/preview-iframe-api' /* webpackChunkName: "dh-preview-iframe" */)
    }
  }

  render() {
    safeDefine('dh-tilpasset-bilde', TilpassetBilde)
  }

  get features() {
    return JSON.parse(this.getAttribute('features'))
  }
}

safeDefine(tag, AppElement)
